import React from 'react';
import './Style/public.scss';
import './Style/cart.scss';
import './Components/lg/login.scss';
import './Style/recommend.scss';
import './Style/bet.scss';
import './Style/trend.scss';
import './Style/recharge.scss';
import Root from "./Router/Route";
import {Provider} from "mobx-react";
import * as mStore from "./stores/store";
import {XDate} from "./Components/dateRange";
import {history} from "./history";
import {thirdStore, userStore} from "./stores/store";
import {createRoot} from "react-dom/client";

window.dispatchEvent(new Event('resize'));
Number.prototype.toFixed = function (a = 0) {
    const va = Math.abs(this);
    const pf = this >= 0 ? '' : '-';
    if (isNaN(this)) return NaN + '';
    const k = Math.pow(10, a);
    const v = (k + Math.floor((va * k) % k) + '')
        .replace(/^1(\d)?/, function (a, b) {
            if (b) return '.' + b;
            return ''
        })
    return pf + Math.floor(va) + v;
};
const fn = () => {
    const root = createRoot(document.getElementById('root'),);
    root.render(
        <Provider {...mStore}>
            <XDate/>
            <Root/>
        </Provider>
    );
    window.dispatchEvent(new Event('resize'));
}
const appOpen = window.isApp && window.App && window.App.open && (s => {
    if(!/^http/.test(s))s=window.location.origin+s;
    window.App.open(s)
});
const _op = window.open;
window.open = function (url, target) {
    if (/^game:\/\//i.test(url)) {
        const {token} = userStore;
        if (!token) return history.push('/login');
        const [type, pid] = url.substr(7).split('_');
        const {code, platform} = thirdStore.game(type, +pid) || {};
        const u = '/launch.html?' + btoa([pid, 1, code, platform, 1, token].join('&'))
        if (appOpen) appOpen(u)
        else return _op(u, 'w' + Date.now());
    } else {
        if (appOpen && /\/launch\.html\?/.test(url)) appOpen(url)
        else return _op.call(window, url, target);
    }
}
const op = window.open;
if (window.isApp && window.isIOS) {
    window.open = url => {
        return op(url, 'w' + Date.now())
    }
    setTimeout(fn, 300)
} else {
    fn()
}

